/**
 * The version a fan reads on the settings screen.
 *
 * This is a hand-maintained mirror of `apps/app/package.json`'s `version`
 * field. The colocated test fails if the two ever disagree.
 *
 * It is deliberately not a Vite `define`: `apps/app`'s colocated tests run
 * under Bun with happy-dom, never through Vite, so a `define` would be a
 * real string in the browser and `undefined` in every test.
 */

export const APP_VERSION = "0.0.1";
